import useVuelidate from '@vuelidate/core';
import dayjs from 'dayjs';
import { V1Scheduler } from 'takeorder-groupbuying-scheduler-js';
import {
  mapActions,
} from 'vuex';
import {
  SNACKBAR_TYPES,
} from '@/utils/constants';
import ScheduleSetting from '@/components/Order/ScheduleSetting/ScheduleSetting.vue';

import { GET_SCHEDULE } from '@/store/orders/constants';

export default {
  name: 'ScheduleListModal',
  components: {
    ScheduleSetting,
  },
  props: {
    order: {
      default: () => ({}),
      type: Object,
    },
    value: {
      default: false,
      type: Boolean,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      groupBuyings: [],
      groupBuyingSetting: {},
      scheduleSetting: {},
      loading: false,
      viewMode: false,
      valid: true,
    };
  },
  async created() {
    try {
      this.loading = true;
      const { schedule: { id: scheduleId } = {} } = this.order || {};
      if (scheduleId) {
        const {
          activate,
          deleted = false,
          disabled = false,
          groupBuyings = [],
          groupBuyingSetting = {},
          scheduleSetting = {},
        } = await this.getSchedule(scheduleId);
        this.groupBuyings = groupBuyings;
        this.groupBuyingSetting = groupBuyingSetting;
        this.scheduleSetting = scheduleSetting;
        let schedules = V1Scheduler.getAllSchedule(scheduleSetting);
        schedules = schedules
          .filter(
            ({ groupBuyingCreateTime: createTime, groupBuyingReceiveTimes: receiveTimes }) => {
              const isExclude = (scheduleSetting?.exclude || [])
                .some((excludeTime) => {
                  const start = dayjs(receiveTimes?.[0]?.[0]).format('YYYY-MM-DD');
                  return excludeTime === start;
                });
              return dayjs().isBefore(dayjs(createTime), 'minute') && !isExclude;
            },
          );
        this.viewMode = !activate || deleted || disabled || !schedules.length;
      } else {
        throw new Error('無法查看此例行性訂購排程');
      }
    } catch (error) {
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: '載入資訊失敗，請重新整理網頁。',
        msg: error?.message || '發生未知錯誤，請再試一次',
      });
      this.close();
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('orders', {
      getSchedule: GET_SCHEDULE,
    }),
    close() {
      this.$emit('close');
    },
    async onSubmit() {
      try {
        const { schedule: { id: scheduleId } = {} } = this.order || {};
        this.loading = false;
        await this.$refs.scheduleSetting.onSubmit(scheduleId);
        this.close();
      } catch (error) {
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: '排程更新失敗，請稍後再試',
          msg: error?.message || '發生未知錯誤，請再試一次',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
